import { Textarea } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { AttributeWrapper } from "./AttributeWrapper";
import { CraAttributeTextArea, CodingAttributes } from "@keita/lanepatrol-sdk";
import { CraAttributeUtils } from "../../../../../../coding/utils/attribute-utils";
import { parseAttributeInputValue } from "../../../../../../coding/utils/attribute-value";
import { useStores } from "../../../../../../shared/stores/RootStore";
import { useAttributeHighlight } from "../../hooks/useAttributeHighlight";
import { OsaNodeCoding } from "../../../../../../coding/models/OsaNodeCoding";

const TextAreaAttributeBase = ({
  attributeDefinition,
  disabled,
  nodeCoding,
  compact,
}: {
  attributeDefinition: CraAttributeTextArea;
  disabled: boolean;
  compact: boolean;
  nodeCoding: OsaNodeCoding;
}) => {
  const { codingStore } = useStores();
  const highlighted = useAttributeHighlight(attributeDefinition);

  if (disabled) return null;

  const currentValue =
    nodeCoding.attributes[attributeDefinition.name as keyof CodingAttributes];
  const inputValue = currentValue ? (currentValue as string) : "";

  return (
    <AttributeWrapper
      attributeDefinition={attributeDefinition}
      label={CraAttributeUtils.getLabel(attributeDefinition.name)}
      compact={compact}
    >
      <Textarea
        size={compact ? "xs" : "md"}
        fontSize={compact ? "xs" : "sm"}
        transitionDuration="0.2s"
        bgColor={highlighted ? `primary.100` : "white"}
        flexGrow={1}
        value={inputValue}
        onChange={(e) => {
          const parsedValue = parseAttributeInputValue(
            attributeDefinition,
            e.target.value,
          );

          codingStore.codeAttribute(attributeDefinition.name, parsedValue);
        }}
        onKeyDown={(e) => e.stopPropagation()}
        placeholder={CraAttributeUtils.getPlaceholder(attributeDefinition.name)}
      />
    </AttributeWrapper>
  );
};
export const TextAreaAttribute = observer(TextAreaAttributeBase);
